import {Entity, EntityInfo} from "../../../shared-components/constants/entities"
import {getEntity} from "../entities/entitiesSelectors"

export const getRefundNumber = (state, id) => {
    const entity = getEntity(state, EntityInfo[Entity.REFUNDS].name, id)
    return entity && entity.refundNumber ? entity.refundNumber : undefined
}
